// extracted by mini-css-extract-plugin
module.exports = {"trigger":"topic-trigger-icon_trigger__ZirXq","trigger__icon":"topic-trigger-icon_trigger__icon__o327E","trigger__text":"topic-trigger-icon_trigger__text__ENTdK"};